<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">
                {{ pageTitle }}
                <em class="ico_info">
                    <i class="tooltip fl_btm">
                        Uploaded images are available to all subsidiaries. Please do not upload images that are specific
                        to certain subsidiaries or individuals.
                    </i>
                </em>
            </h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srchQna_wrap pb20">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w100">
                            <li class="tit_150">{{ $t('FIELD.MYKNOWLEDGE.KEYWORD') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <span class="clearable">
                                    <input
                                        type="text"
                                        class="text_input"
                                        placeholder="Enter a file name or hashtag"
                                        v-clearable
                                        v-model="searchName"
                                    />
                                </span>
                            </li>
                        </ul>
                        <ul class="w100">
                            <li class="tit_150">{{ $t('FIELD.GLOBAL.CATEGORY') }}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_3">
                                    <div>
                                        <select
                                            class="slt_white w100p"
                                            v-model="category1Code"
                                            @change="categoryList(2)"
                                        >
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category1CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select
                                            class="slt_white w100p"
                                            v-model="category2Code"
                                            @change="categoryList(3)"
                                        >
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category2CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100p" v-model="category3Code">
                                            <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                            <option
                                                v-for="item in category3CodeList"
                                                :key="pageName + item.code"
                                                :value="item.code"
                                            >
                                                {{ item.codeName }}
                                            </option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR">
                        <a href="javascript:" class="btn_srch" @click="onSearch(1)">
                            {{ $t('BUTTON.GLOBAL.SEARCH') }}
                        </a>
                    </div>
                </article>
            </div>
            <!--hashtag_list-->
            <ul class="hashtag_list">
                <li v-for="item in keyword" :key="item.KEY_WORD + item.HIT_COUNT + item.REG_DT">
                    <a href="javascript:" @click="searchKeyword(item.KEY_WORD)">{{ item.KEY_WORD }}</a>
                </li>
            </ul>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Count -->
                <div class="grid_total">
                    {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ totalCount }}</em>
                </div>
                <!-- 
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_blue" @click="imageCloudListPopup()">
                        {{ $t('BUTTON.GLOBAL.CREATE') }}
                    </a>
                </div>
                 -->
                <div class="btn_wrap" v-if="'Y' === params.creationYn">
                    <a href="javascript:" class="btn_gray" @click="pageMove()">
                        {{ $t('BUTTON.GLOBAL.CREATE') }}
                    </a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :columns="columns"
                    :data="gridData"
                    :options="options"
                    :ref="gridId"
                    :key="gridKey"
                    :isTotalCount="false"
                    :click="contentClick"
                />
                <div class="paginate">
                    <sdl-pagination
                        align="center"
                        :current-page="currentPage"
                        :total-rows="totalCount"
                        :per-page="nRecordsPerPage"
                        @change="onSearch"
                    />
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

/* import imageCloudListPopup from '~va/tool/imageCloudListPopup'; */

export default {
    name: 'imageCloudList',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    data() {
        return {
            pageName: 'imageCloudList',
            pageTitle: '',
            searchName: '',
            category1Code: '',
            category2Code: '',
            category3Code: '',
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            keyword: [],
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            gridKey: 0,
            gridId: 'imageCloudListGrid',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'),
                    name: 'CATEGORY_NM',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'),
                    name: 'TITLE',
                    align: 'center',
                    // width: 125,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'File Format',
                    name: 'FILE_FORMAT',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'File Size',
                    name: 'FILE_SIZE',
                    align: 'center',
                    // width: 375,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('BUTTON.NOTICE.PREVIEW'),
                    name: 'PRE_VIEW',
                    align: 'center',
                    // width: 175,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
        };
    },
    mounted() {
        this.categoryList(1);
        this.onSearch(1);
    },
    computed: {
        ...mapGetters({
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
            menus: 'getMenus',
            corpCd: 'getCorpCd',
            params: 'getParams',
        }),
    },
    methods: {
        searchKeyword(v) {
            this.searchName = v;
            this.onSearch(this.currentPage);
        },
        async onSearch(v) {
            //TODO 이국현프로님 증정
            let searchName = this.searchName.split(' ').filter(s => s.length > 0);
            searchName.push(this.searchName);

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/imageCloud/imageList.skp`,
                    qs.stringify({
                        page: v,
                        searchName: searchName,
                        category1: this.category1Code,
                        category2: this.category2Code,
                        category3: this.category3Code,
                    }),
                )
                .then(resp => {
                    this.gridData = resp.data.result;
                    this.keyword = resp.data.search.keyword.rowData;
                    for (const iterator of this.gridData) {
                        if (0 === iterator.attach.rowData.length) {
                            iterator.PRE_VIEW = '<img src="/static/images/ico_preview.png">';
                        } else {
                            let url = this.getDownloadUrl(
                                iterator.attach.rowData[0].ENC_ATTCH_FILE_SEQ,
                                iterator.attach.rowData[0].ENC_TOKEN,
                            );
                            iterator.crossUrl =
                                `${SDLUtil.API_URL}/skp_files/skp_attach` +
                                iterator.attach.rowData[0].FILE_DIR.split('skp_attach')[1].replace(/\\/gi, '/');
                            iterator.PRE_VIEW =
                                '<a href="' +
                                iterator.crossUrl +
                                '" target="_blank"><img src="/static/images/ico_preview.png"></a>';
                        }
                    }

                    this.totalCount = resp.data.search.totalRecords;
                    this.currentPage = Number(resp.data.search.page);
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1Code = '';
                this.category2Code = '';
                this.category3Code = '';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category1CodeList = resp;
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2Code = '';
                this.category3Code = '';
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category2CodeList = resp;
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3Code = '';
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category3CodeList = resp;
                });
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
        pageMove() {
            return this.$router.push({ name: 'imageCloudDetail' });
        },
        contentClick(e, rowData, grid) {},
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN;
        },
        // imageCloudListPopup() {
        //     SDLUtil.show(
        //         imageCloudListPopup,
        //         {},
        //         {
        //             width: '500px',
        //             height: 'auto',
        //         },
        //     );
        // },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/tool/imageCloudList.vue